import React from 'react';
import FuelEnquiryList from './FuelEnquiryList';
import './FuelEnquiriesTab.css';

// Thin wrapper. The whole tab is gated by ``commodityType === 'fuels'`` so a
// Solids user never sees Fuels enquiries (Q29 + ``TRADE_OPS_SOLIDS_FUELS_
// SPLIT.md`` §"What's intentionally NOT split"). Sprint 1E adds the form /
// detail panel; Sprint 1D ships the list only.
const FuelEnquiriesTab = ({ commodityType }) => {
  if (commodityType !== 'fuels') return null;

  return (
    <div className="tab-content-wrapper fuel-enquiries-tab-wrapper">
      <FuelEnquiryList commodityType={commodityType} />
    </div>
  );
};

export default FuelEnquiriesTab;
